import { CheckCircleIcon, ExclamationCircleIcon, NoSymbolIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

function UplaodingStatusMessage({ status }: { status: "uploading" | "success" | "failed" | "aborted" }) {
  return (
    <span className="flex items-center gap-0.5 text-xxs">
      {/* eslint-disable-next-line no-nested-ternary */}
      {status === "uploading" ? (
        <>
          Uploading<span className="three-dots-loading">...</span>
        </>
      ) : // eslint-disable-next-line no-nested-ternary
      status === "failed" ? (
        <>
          <ExclamationCircleIcon className="h-4 w-4" />
          Uploading Media Failed
        </>
      ) : status === "aborted" ? (
        <>
          <NoSymbolIcon className="h-5 w-5" />
          File Upload Aborted
        </>
      ) : (
        <>
          <CheckCircleIcon className="h-5 w-5" />
          File Uploaded Successfully
        </>
      )}
    </span>
  );
}

function ProgressBar({
  progress,
  status,
}: {
  progress?: number;
  status: "uploading" | "success" | "failed" | "aborted";
}) {
  return (
    <div className="mt-4">
      <div className="mb-1 flex justify-between">
        <span
          className={clsx(
            "text-base",
            // eslint-disable-next-line no-nested-ternary
            status === "success" ? "text-green-400" : status === "failed" ? "text-red-400" : "text-neutral-200",
          )}
        >
          <UplaodingStatusMessage status={status} />
        </span>
        {status === "uploading" && <span className="text-base font-medium text-white">{progress}%</span>}
      </div>
      {status === "uploading" && (
        <div className="h-2.5 w-full rounded-full bg-gray-700">
          <div className="h-2.5 rounded-full bg-blue-500" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );
}
export default ProgressBar;
